
export class WorkflowStep {
    id?;
    createTime?;
    stepId?;
    stepCode?;
    status?;
    workflowDefinitionId?;
    stepType?;
    httpRequest?;
    deadline?;
    isDate?;
    persistenceId?;
    workflowForms = [];
    workflowCompleteForms = [];
    workflowTemplates = [];
    autoFinish?;
    stepName?;
    key?;
    value?;
}
